import { Component, OnInit } from "@angular/core";
import { DateAdapter } from "@angular/material/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/core/auth/services/auth.service";
import { PropertyService } from "src/app/services/property/property.service";
import { locationRead, roleRead } from "../../../app.constants";
import { clientRead, deviceRead, userRead } from "./../../../app.constants";
import { Languages } from "./../../../models/properties/languages.model";

@Component({
  selector: "lns-topnav",
  templateUrl: "./topnav.component.html",
  styleUrls: ["./topnav.component.scss"],
})
export class TopnavComponent implements OnInit {
  loginPage = true;
  clientCanRead = clientRead;
  deviceCanRead = deviceRead;
  roleCanRead = roleRead;
  userCanRead = userRead;
  locationCanRead = locationRead;
  username: string;
  childrenMessageActive = false;
  childrenAuditLogsActive = false;
  languages: Languages;

  constructor(
    public authService: AuthService,
    private translate: TranslateService,
    private router: Router,
    private adapter: DateAdapter<any>,
    private propertyService: PropertyService
  ) {
    router.events.subscribe(() => {
      if (router.url.startsWith("/messages")) {
        this.childrenMessageActive = true;
      } else {
        this.childrenMessageActive = false;
      }
    });

    router.events.subscribe(() => {
      if (router.url.startsWith("/audit-logs")) {
        this.childrenAuditLogsActive = true;
      } else {
        this.childrenAuditLogsActive = false;
      }
    });
  }

  ngOnInit() {
    const currentLang = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";

    this.translate.use(currentLang);
    this.adapter.setLocale(currentLang);
    this.username = this.authService.getCurrentUserEmail();
    this.getLanguages();
  }

  switchLanguage(language: string) {
    const lang = language.toLowerCase();
    this.translate.use(lang);
    localStorage.setItem("language", lang);
    this.adapter.setLocale(lang);
  }

  logout() {
    this.authService.logout();
  }

  showNavLink(privilege?: string) {
    const isLogged = this.authService.isAuthenticatedOrRefresTokenNotExpired();
    if (!privilege) {
      return isLogged;
    }
    return isLogged && this.authService.hasPrivilege(privilege);
  }

  getLanguages() {
    this.propertyService.languages().subscribe((response) => {
      this.languages = response.body;
    });
  }
}
